// extracted by mini-css-extract-plugin
export var scrollArea = "_p2-0";